module.exports = __webpack_public_path__ + "media/customizations/trailselizabethcreek/back-c4254288188c59cb705bf6017ed21911.jpg";